import API from "./api";

const TypeArticleService = {
  getAll: async () => {
    const response = await API.get("/types-articles");
    return response.data.donnees;
  },

  getById: async (id: number) => {
    const response = await API.get(`/types-articles/${id}`);
    return response.data.donnees;
  },

  create: async (payload: any) => {
    const response = await API.post("/types-articles", payload);
    return response.data.donnees;
  },

  update: async (id: number, payload: any) => {
    const response = await API.put(`/types-articles/${id}`, payload);
    return response.data.donnees;
  },

  delete: async (id: number) => {
    const response = await API.delete(`/types-articles/${id}`);
    return response.data.donnees;
  },
};

export default TypeArticleService;
